/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ManagedByConsole } from './components';

export const BackupJobsManagedByConsolePage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <ManagedByConsole />
    </TabBarBodyLayout>
);
